// src/pages/test-series/PyqTestSeriesPage.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaTachometerAlt,
  FaChartBar,
  FaRedoAlt,
  FaUserCheck,
  FaArrowRight
} from 'react-icons/fa';
import Footer from '../Footer';
import SocialSidebar from '../../components/SocialSideBar';
import styles from './PyqTestSeriesPage.module.css';

const PyqTestSeriesPage = () => {
  const features = [
    {
      key: 'interface',
      title: 'Real Exam Interface',
      description: 'Experience the same UI, section switching, and on-screen timer as the official exam platform.',
      icon: <FaTachometerAlt />
    },
    {
      key: 'report',
      title: 'Instant Performance Report',
      description: 'Get your detailed performance analysis report immediately after you submit the test.',
      icon: <FaChartBar />
    },
    {
      key: 'attempts',
      title: 'Unlimited Attempts',
      description: 'Reattempt any paper as many times as you want to boost speed and confidence.',
      icon: <FaRedoAlt />
    },
    {
      key: 'saved',
      title: 'Saved Results on Profile',
      description: 'Your past attempts and scores are stored on your profile so you can track your progress over time.',
      icon: <FaUserCheck />
    }
  ];

  const testCategories = [
    {
      id: 'jee-mains',
      title: 'PYQ Mock Tests (JEE Mains)',
      emoji: '🏆',
      description: 'Practice: JEE Mains Question Papers (2015-2025).',
      testsCount: '38',
      duration: '180 min',
      subjects: 'Physics, Chemistry, Mathematics',
      route: '/test-series/pyq/jeemains',
      color: '#3b82f6'
    },
    {
      id: 'neet',
      title: 'PYQ Mock Tests (NEET)',
      emoji: '🧬',
      description: 'Practice: NEET Question Papers (2022-2025).',
      testsCount: '12(Coming More..)',
      duration: '200 min',
      subjects: 'Physics, Chemistry, Biology',
      route: '/test-series/pyq/neet',
      color: '#10b981'
    },
    
    {
      id: 'jee-advanced',
      title: 'PYQ Mock Tests (JEE Adv)',
      emoji: '🎯',
      description: 'Practice: JEE Advanced Question Papers (Upcoming..).',
      testsCount: '1(Will Upload soon)',
      duration: '180 min',
      subjects: 'Physics, Chemistry, Mathematics',
      route: '/test-series/pyq/jeeadv',
      color: '#8b5cf6'
    },
    
  ];

  return (
    <div className={styles.categoryPageContainer}>
      <SocialSidebar />

      {/* PROFESSIONAL HERO SECTION */}
      <header className={styles.heroSection}>
        <div className={styles.heroContent}>
          <div className={styles.badgeExam}>
            🔥 100% Free Forever • No Hidden Charges
          </div>
          <h1 className={styles.pageTitle}>
            🎯 Most Authentic Mock Tests for JEE Mains, JEE Adv. & NEET
          </h1>
          
          <p className={styles.pageSubtitle}>
            Practice actual PYQ papers as Mock tests for <span className={styles.highlight}>JEE Mains, JEE Advanced & NEET</span>. 
            Experience real exam conditions ⏱️ with instant detailed solutions.
          </p>
          <button
            className={styles.startPracticeBtn}
            onClick={() => {
              const el = document.querySelector(`.${styles.testCategoriesSection}`);
              if (el) el.scrollIntoView({ behavior: "smooth" });
            }}
          >
            Available Test Categories ⮟
          </button>
        </div>
      </header>
      {/* FEATURES SECTION */}
      <section className={styles.featuresSection}>
        <h2 className={styles.sectionHeading}>✨ Key Features</h2>
        <div className={styles.featuresGrid}>
          {features.map((feature, index) => (
            <div key={feature.key} className={styles.featureCard}>
              <div className={styles.featureIcon}>
                {feature.icon}
              </div>
              <h3 className={styles.featureTitle}>{feature.title}</h3>
              <p className={styles.featureDescription}>{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* TEST CATEGORIES GRID */}
      <section className={styles.testCategoriesSection}>
        <h2 className={styles.sectionHeading}>📚 Available Test Categories</h2>
        <p className={styles.sectionSubtext}>Choose your exam and start practicing with authentic previous year papers</p>
        
        <div className={styles.testsGrid}>
          {testCategories.map((category) => (
            <Link 
              key={category.id} 
              to={category.route} 
              className={styles.testCard}
            >
              <div className={styles.cardHeader}>
                <span className={styles.testEmoji}>{category.emoji}</span>
                <span className={styles.testBadge}>100% Free</span>
              </div>
              
              <h3 className={styles.cardTitle}>{category.title}</h3>
              <p className={styles.cardDescription}>{category.description}</p>
              
              <div className={styles.cardStats}>
                <div className={styles.statItem}>
                  <span className={styles.statLabel}>Tests</span>
                  <span className={styles.statValue}>{category.testsCount}</span>
                </div>
                <div className={styles.statItem}>
                  <span className={styles.statLabel}>Duration</span>
                  <span className={styles.statValue}>{category.duration}</span>
                </div>
              </div>
              
              <div className={styles.cardSubjects}>
                <span className={styles.subjectsLabel}>📖</span>
                <span className={styles.subjectsText}>{category.subjects}</span>
              </div>
              
              <div className={styles.cardFooter}>
                <span className={styles.viewButton}>
                  Start Practicing <FaArrowRight />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PyqTestSeriesPage;